class MbPurchaseBar extends HTMLElement {
  connectedCallback() {
    this.root = document.querySelector(`.main-product--root[data-product-id="${this.dataset.productRoot}"]`);
    this.form = this.root?.querySelector('form.product-form');
    this.primary = this.form?.querySelector('product-buy-buttons-element > .product-buy-buttons--primary');
    if (!this.primary || this.controller) return;
    this.controller = new AbortController();
    this.variants = JSON.parse(this.querySelector('script').textContent);
    this.button = this.querySelector('[data-mb-bar-buy]');
    this.shirt = this.dataset.shirt === 'true';
    this.chosen = !this.shirt;
    this.unlocked = false;
    this.primaryVisible = false;
    this.footerVisible = false;
    this.media = matchMedia('(max-width: 767px)');
    const options = {signal: this.controller.signal};
    this.form.addEventListener('click', event => {
      if (event.target.closest('[data-block-type="options"] input, [data-block-type="options"] label')) this.chosen = true;
      requestAnimationFrame(() => this.update());
    }, options);
    this.form.addEventListener('change', () => requestAnimationFrame(() => this.update()), options);
    this.media.addEventListener('change', () => this.update(), options);
    this.button.addEventListener('click', () => {
      if (this.shirt && !this.chosen) {
        const option = this.form.querySelector('[data-block-type="options"]');
        option?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        option?.querySelector('input:checked, input, button')?.focus({preventScroll:true});
      } else if (!this.primary.disabled && this.primary.getAttribute('aria-busy') !== 'true') {
        this.primary.click();
      }
    }, options);
    this.observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target === this.primary) this.primaryVisible = entry.isIntersecting;
        else if (entry.target.matches('footer,.section--footer')) this.footerVisible = entry.isIntersecting;
        else if (entry.isIntersecting) this.unlocked = true;
      }
      this.update();
    });
    this.observer.observe(this.primary);
    const heading = this.form.querySelector('h1');
    if (heading) this.observer.observe(heading);
    const footer = document.querySelector('footer,.section--footer');
    if (footer) this.observer.observe(footer);
    this.changes = new MutationObserver(() => this.update());
    this.changes.observe(this.form,{subtree:true,attributes:true,attributeFilter:['disabled','aria-busy','value','data-id']});
    const viewport = document.querySelector('.layout--viewport');
    if (viewport) this.changes.observe(viewport,{attributes:true,attributeFilter:['data-drawer-status']});
    this.update();
  }
  update() {
    const id = this.form.querySelector('input[name="id"]')?.value;
    const variant = this.variants.find(x => String(x.id) === String(id));
    const busy = this.primary.getAttribute('aria-busy') === 'true';
    this.button.disabled = this.primary.disabled || !variant?.available || busy;
    this.button.setAttribute('aria-busy',String(busy));
    this.button.textContent = this.button.disabled && !busy ? this.dataset.sold : !this.chosen ? this.dataset.choose : this.dataset.add;
    this.querySelector('[data-mb-bar-price]').textContent = variant?.price || '';
    this.querySelector('[data-mb-bar-size]').textContent = this.shirt && this.chosen ? variant?.title || '' : '';
    const drawerStatus = document.querySelector('.layout--viewport')?.dataset.drawerStatus;
    this.hidden = !this.media.matches || !this.unlocked || this.primaryVisible || this.footerVisible || (drawerStatus && drawerStatus !== 'closed');
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.changes?.disconnect();
    this.controller = null;
  }
}
if (!customElements.get('mb-purchase-bar')) customElements.define('mb-purchase-bar',MbPurchaseBar);
